import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	modalHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	captureIdeas: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	logIdeas: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	prioritizeWithData: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	shareRoadmaps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectToJira: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	close: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	getStarted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalSubHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ariaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectTitleProductRoadmap: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectTitlePrioritization: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	modalHeading: {
		id: 'jpd-project-directory-onboarding-modal.modal.heading',
		defaultMessage: 'Welcome to Jira Product Discovery',
		description: 'Heading for the Jira Product Discovery onboarding modal',
	},
	modalDescription: {
		id: 'jpd-project-directory-onboarding-modal.modal.description',
		defaultMessage: 'Here’s a few things you can use it for:',
		description: 'Description text introducing the list of onboarding features',
	},
	captureIdeas: {
		id: 'jpd-project-directory-onboarding-modal.capture-ideas',
		defaultMessage: 'Easily capture ideas and insights in one place',
		description: 'Feature: capturing ideas and insights',
	},
	logIdeas: {
		id: 'jpd-project-directory-onboarding-modal.log-ideas',
		defaultMessage: 'Log ideas and use insights to prioritize them',
		description: 'Feature: capturing ideas and insights',
	},
	prioritizeWithData: {
		id: 'jpd-project-directory-onboarding-modal.prioritize-with-data',
		defaultMessage: 'Use data and insights to prioritize them',
		description: 'Feature: using data and insights to prioritize ideas',
	},
	shareRoadmaps: {
		id: 'jpd-project-directory-onboarding-modal.share-roadmaps',
		defaultMessage: 'Share custom roadmaps with anyone',
		description: 'Feature: sharing custom roadmaps',
	},
	connectToJira: {
		id: 'jpd-project-directory-onboarding-modal.connect-to-jira',
		defaultMessage: 'Easily connect ideas into Jira for delivery',
		description: 'Feature: connecting ideas into Jira for delivery',
	},
	close: {
		id: 'jpd-project-directory-onboarding-modal.close',
		defaultMessage: 'Close',
		description: 'Button text to close the onboarding modal',
	},
	getStarted: {
		id: 'jpd-project-directory-onboarding-modal.get-started',
		defaultMessage: 'Get started',
		description: 'Button text to begin using the product',
	},
	modalSubHeading: {
		id: 'jpd-project-directory-onboarding-modal.modal.sub-heading',
		defaultMessage: 'Here’s a few things you can use it for:',
		description: 'Sub-heading for the Jira Product Discovery onboarding modal',
	},
	ariaLabel: {
		id: 'jpd-project-directory-onboarding-modal.aria-label',
		defaultMessage: 'Jira Product Discovery onboarding modal',
		description: 'Aria label for the onboarding modal',
	},
	projectTitleProductRoadmap: {
		id: 'jpd-project-directory-onboarding-modal.project-title.product-roadmap',
		defaultMessage: 'Product roadmap',
		description: 'Product roadmap project title of JPD',
	},
	projectTitlePrioritization: {
		id: 'jpd-project-directory-onboarding-modal.project-title.prioritization',
		defaultMessage: 'Prioritization',
		description: 'Prioritization project title of JPD',
	},
});
export default messages;
